module.exports = __webpack_public_path__ + "img/option_circle_brd.5ab58776.png";